class LoyaltyPoints extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const token = "a041e926117673199463f0c686908230";
    const userId = "31742";
    const customerId = this.getAttribute("data-customer-id");
    this.loader = this.querySelector(".loyalty-plan-loader");
    const apiUrl = `https://app.getflits.com/api/1/${userId}/${customerId}/credit/get_credit?token=${token}`;

    this.getData(apiUrl);
  }

  async getData(apiUrl) {
    await fetch(apiUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-integration-app-name": "Lets_hyphen",
      },
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok " + response.statusText);
        }
        return response.json(); 
      })
      .then((data)=>{
        this.updateData(data);
      })
      .catch((error) => {
        this.loader.classList.add("hidden");
        console.error("Fetch error:", error);
      });
  }

  updateData(data) {
    this.loyaltyPoints = this.querySelector(".loyalty-points");
    this.loyaltyPoints.innerHTML = data.customer.credits/100;
    this.loader.classList.add("hidden");
  }
}

customElements.define("loyalty-points", LoyaltyPoints);

document.addEventListener("DOMContentLoaded", () => {
  const editButtons = document.querySelectorAll(".side-bar__profile-edit");

  editButtons.forEach((button) => {
    const wrapper = button.closest(".user-profile__side-bar-wrapper");
    const popupOverlay = wrapper?.querySelector(".customer_data-popup-overlay");

    if (!popupOverlay) return;

    button.addEventListener("click", () => {
      popupOverlay.classList.remove("hidden");
    });

    popupOverlay.addEventListener("click", (event) => {
      if (event.target === popupOverlay) {
        popupOverlay.classList.add("hidden");
      }
    }); 
  });
});

if (!customElements.get("account-delete")) {
  class AccountDelete extends HTMLElement {
    constructor() {
      super();
      this.handleClick = this.handleClick.bind(this);
    }

    connectedCallback() {
      this.button = this.querySelector(".account-delete-trigger");
      this.label = this.querySelector(".account-delete-label");
      this.messageEl = this.querySelector(".account-delete-message");

      if (this.button) {
        this.button.addEventListener("click", this.handleClick);
      }
    }

    disconnectedCallback() {
      if (this.button) {
        this.button.removeEventListener("click", this.handleClick);
      }
    }

    showMessage(message, type = "success") {
      if (!this.messageEl) return;

      this.messageEl.textContent = message;
      this.messageEl.className = `account-delete-message ${type}`;
      this.messageEl.style.display = "block";
    }

    setLoading(isLoading) {
      if (!this.button || !this.label) return;

      if (isLoading) {
        this.button.style.pointerEvents = "none";
        this.button.classList.add("is-loading");
        this.label.textContent = "Submitting Request...";
      } else {
        this.button.style.pointerEvents = "";
        this.button.classList.remove("is-loading");

        if (this.label.textContent !== "Request Submitted") {
          this.label.textContent = "Delete Account";
        }
      }
    }

    async handleClick(event) {
      event.preventDefault();

      if (this.classList.contains("loading")) return;

      try {
        this.classList.add("loading");
        this.setLoading(true);

        const customerData = {
          customer_id: this.dataset.customerId || "",
          first_name: this.dataset.firstName || "",
          last_name: this.dataset.lastName || "",
          email: this.dataset.email || "",
          phone: this.dataset.phone || "",
          submitted_date: new Date().toLocaleString(),
          status: "Deletion Requested"
        };

        const formData = new URLSearchParams();

        Object.entries(customerData).forEach(([key, value]) => {
          formData.append(key, value);
        });

        const response = await fetch(
          "https://script.google.com/macros/s/AKfycbwTOl2PZjlh_d0OIcfL2PEC9qSnCAcPUGm7vbKu1_2P8LZ9qcMOu7yGJRzwC8c5VnnY/exec",
          {
            method: "POST",
            body: formData
          }
        );

        const text = await response.text();
        const result = JSON.parse(text);

        if (result.result === "success") {
          if (window.clevertap) {
            clevertap.event.push("account_delete", {
              customer_id: customerData.customer_id,
              email: customerData.email
            });
          }

          this.showMessage(
            "Account deletion request received. It will be processed within 3–4 days.",
            "success"
          );

          this.button.style.pointerEvents = "none";
          this.label.textContent = "Request Submitted";

          setTimeout(() => {
            window.location.href = "/account/logout";
          }, 3000);
        } else {
          this.showMessage(
            result.error || "Something went wrong. Please try again.",
            "error"
          );
        }

      } catch (error) {
        console.error(error);

        this.showMessage(
          "Something went wrong. Please try again.",
          "error"
        );

      } finally {
        this.classList.remove("loading");

        if (this.label.textContent !== "Request Submitted") {
          this.setLoading(false);
        }
      }
    }
  }

  customElements.define("account-delete", AccountDelete);
}